<template>
  <div class="container">
    <p class="title">
      Leave MyCircle
    </p>
    <div class="card">
      <p class="card-title">Delete</p>
      <p class="card-info">
        All of your data will be removed from our system and will not be used
        for future research. Deleting your account will take 5 days to process.
        You will be unable to reactivate your account after the 5 day period.
      </p>
      <a-button
        class="button"
        @click="checkAuth"
        :disabled="isDeleted()"
        :style="{ background: isDeleted() ? '#dedede' : '#2a71d4' }"
        :loading="loading"
      >
        Delete
      </a-button>
    </div>
    <GenericConfirmModal
      ref="confirmModal"
      confirm_text="account"
      :handleConfirm="actionText => deleteAccount()"
      :canUndo="true"
    />
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../repositories/RepositoryFactory";
import GenericConfirmModal from "../../Modals/GenericConfirmModal.vue";

const LeaveCircleRepository = RepositoryFactory.get("leaveCircle");

export default {
  name: "LeaveCircle",
  components: {
    GenericConfirmModal
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    SSO_BASE_URL: () => process.env.SSO_BASE_URL
  },
  methods: {
    checkAuth() {
      if (!this.authUser) {
        const currentPath = encodeURIComponent(window.location.href);
        window.location.href = `${process.env.SSO_BASE_URL}/dovemed-sso?next=${currentPath}`;
      } else {
        this.openConfirmModal("delete");
      }
    },
    isDeleted() {
      const delete_all = JSON.parse(localStorage.getItem("delete_all"));
      return delete_all;
    },
    openConfirmModal(actionText) {
      this.$refs.confirmModal._data.actionText = actionText;
      this.$refs.confirmModal.open(actionText);
    },
    deleteAccount() {
      this.loading = true;
      LeaveCircleRepository.deleteAll()
        .then(res => {
          this.$refs.confirmModal.hide();
          this.$notification.success({
            message: "Successful",
            description: `Account deletion successfully initiated`
          });
          this.loading = false;
          localStorage.setItem("delete_all", JSON.stringify(true));
        })
        .catch(e => {
          this.$refs.confirmModal.hide();
          this.loading = false;
          this.$notification.error({
            message: "Error",
            description: `Unsuccessful`
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 10px;
  @media only screen and (max-width: 710px) {
    padding: 24px;
  }
}
.title {
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #0f1734;
  margin-bottom: 24px;
}

.card {
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 2px 8px rgba(60, 60, 60, 0.1);
  margin-bottom: 24px;
  padding: 24px;
  border-color: #ffffff;
}

.card-title {
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #0f1734;
  margin-bottom: 16px;
}

.card-info {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #47556e;
  margin-bottom: 16px;
}

.button {
  padding: 12px 24px;
  border-radius: 6px;
  width: fit-content;
  border: none;
  font-weight: 700;
  font-size: 14px;
  color: #ffffff;
  background-color: #2a71d4;
}
.button:hover {
  background-color: #2a71d4;
}
</style>



// WEBPACK FOOTER //
// src/components/App/circle/Settings.vue